import type { FaireProductEntity } from "../../entity_types/product";

export const p_ztw92m8jn4: FaireProductEntity = {
  token: "p_ztw92m8jn4",
  type: "product",
  name: "Yumearth Organic Fruit Snacks 12/2OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl: "https://cdn.faire.com/fastly/b24d0f441fdfa54eef94e35fedbc9f878a23649593a26c878e65fd6e06000bdc.jpeg",
  galleryImageUrls: [],
  priceDollars: 71.64,
  description: "Organic fruit snacks, 12 units at 2oz each, Yumearth natural gummies made with organic ingredients",
  tags: [],
  msrpDollars: 142.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:56.564Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
